module.exports = __webpack_public_path__ + "public/images/stands-bg-1@2x.fdee23f2d7dd1d71bd864cd0f5525001.webp";